import { Pipe, PipeTransform } from "@angular/core";
import { BreadcrumbService } from "@shared/services";

@Pipe({
    name: "nombreAmigableRuta",
    pure: false
})
export class NombreAmigableRutaPipe implements PipeTransform {
    constructor(private breadcrumbService: BreadcrumbService) {}

    transform(url: string): string {
        return !url ? "" : this.breadcrumbService.obtenerNombreAmigable(url);
    }

}
